<style>
  @import url("https://fonts.googleapis.com/css?family=Fira+Sans:500");
</style>
<app-top-nav></app-top-nav>
<div class="bg-light" style="
    height: calc(100% - 60px);
    padding-top: 25px;
    padding-left: 25px;
    overflow-x: auto;
  ">
  <div class="pl-4 mb-3 ml-1">
    <p i18n="@@admin.users.title.manageusers">manage <b>users</b></p>
    <p><b i18n="@@admin.users.userlist">user list</b></p>
  </div>

  <form [formGroup]="userForm" class="parent">
    <div class="col-5">
      <div class="card" formArrayName="FirstUsersGroupOverview"
        *ngFor="let user of userForm.get('FirstUsersGroupOverview').value">
        <div class="username">
          {{ user.firstName }} {{ user.lastName
          }}<span *ngIf="user.lockoutEnabled" class="big-red-exclamation-mark">!</span>
        </div>
        <div class="roles">
          <span *ngFor="let role of user.roles; let last = last">
            {{ role.roleName }}<span *ngIf="!last">,</span>
          </span>
        </div>
        <div class="actions">
          <span class="btn-group pl-2">
            <img src="assets/Keen&Wise_edit_round-138.png" class="btn-image clickable" data-toggle="modal"
              (click)="editUser(user)" />
            <img src="assets/Keen&Wise_delete_round.png" class="btn-image clickable" (click)="onDeleteUser(user)" />
          </span>
        </div>
      </div>
    </div>

    <div class="col-5">
      <div class="card" formArrayName="FirstUsersGroupOverview"
        *ngFor="let user of userForm.get('SecondUsersGroupOverView').value">
        <div class="username">
          {{ user.firstName }} {{ user.lastName
          }}<span *ngIf="user.lockoutEnabled" class="big-red-exclamation-mark">!</span>
        </div>
        <div class="roles">
          <span *ngFor="let role of user.roles; let last = last">
            {{ role.roleName }}<span *ngIf="!last">,</span>
          </span>
        </div>
        <div class="actions">
          <span class="btn-group pl-2">
            <img src="assets/Keen&Wise_edit_round-138.png" class="btn-image clickable" data-toggle="modal"
              (click)="editUser(user)" />
            <img src="assets/Keen&Wise_delete_round.png" class="btn-image clickable" (click)="onDeleteUser(user)" />
          </span>
        </div>
      </div>
    </div>
  </form>

  <div class="create-user">
    <a><img class="admin-button-image" src="assets/Keen&Wise_create new user.png" id="btn-create-image"
        (click)="createUser()" /></a>
  </div>
</div>
<app-add-user (UserAdded)="receiveUserAddedFromChild($event)"></app-add-user>
<app-admin-edit-user
  [selectedUser]="selectedUser"
  (UserEdited)="receiveUserEditedFromChild($event)"
  (unlockUser)="onUnlockUser($event)"
></app-admin-edit-user>
